import Store from 'store/store';
import movieStatusUtilsFactory from 'utils/cms/v2/movieStatus';

const getIsFocus = () => {
	return Store.get().domains?.isFocus || false;
};

const getRegionCode = () => {
	const { regions, selectedRegion } = Store.get().domains || {};
	const region = regions?.find(r => r.region_id === selectedRegion);
	return region?.region_code || 'us';
};

export const { getMovieStatus, getAllMovieStatuses } = movieStatusUtilsFactory({
	getIsFocus,
	getRegionCode,
});
